
  // Function to get the auth token from session storage
// Function to get the auth token from either localStorage or sessionStorage
const getAuthToken = () => {
  let token = localStorage.getItem('token') || sessionStorage.getItem('token');

  // Check if token is found in either storage
  if (!token) {
    console.error("Auth token not found in localStorage or sessionStorage.");
    
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Redirect to login page
    alert('Session expired. Please login again.');
    window.location.href = '/login';
    
    return null;
  }

  // Remove extra quotes if present
  token = token.replace(/^"(.*)"$/, '$1'); // Removes surrounding quotes if they exist

  return token;
};


// Function to set up headers
const getHeaders = () => {
  let token = getAuthToken();

  // Check if token is null or undefined
  if (!token) {
    console.error("Cannot create headers: Auth token is null or undefined.");
    return {
      headers: {
        Authorization: '',
      },
    };
  }

  // Ensure 'Bearer' is not added twice
  if (!token.startsWith('Bearer ')) {
    token = `Bearer ${token}`;
  }

  return {
    headers: {
      Authorization: token,
    },
  };
};



  export {
getAuthToken,
getHeaders,

  }